import {create} from 'zustand';
import OfflineService from '../../api/admin/offlineService';

interface OfflineServiceState {
  orders: any[];
  order: any;
  totalCount: number;
  pageSize: number;
  page: number;
  totalPages: number;

  // Фильтры
  email: string;
  status: string | null;
  uploadedFrom: string; // в виде строки для input[type="date"]
  uploadedTo: string;
  software: string;

  // Действия
  clearOrders: () => void;
  fetchOrders: (mode: string) => Promise<void>;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
  setEmail: (email: string) => void;
  setStatus: (status: string | null) => void;
  setUploadedFrom: (date: string) => void;
  setUploadedTo: (date: string) => void;
  resetFilters: () => void;
  setSelectedFile: (file: File | null) => void;
  selectedFile: File | null;
  fetchOrder: (id: number) => Promise<void>;
  setSoftware: (software: string) => void;
}

const useOfflineServiceStore = create<OfflineServiceState>((set, get) => ({
  orders: [],
  order: undefined,
  totalCount: 0,
  pageSize: 20,
  page: 1,
  totalPages: 1,

  // Фильтры
  email: '',
  status: null,
  uploadedFrom: '',
  uploadedTo: '',
  software: '',

  selectedFile: null,

  clearOrders: () => set({ orders: [] }),

  fetchOrders: async (mode: string) => {
    const { page, pageSize, email, status, uploadedFrom, uploadedTo, software } = get();
    const offlineService = new OfflineService();

    // Подготовка параметров
    const params: Record<string, string> = {
      page: page.toString(),
      pageSize: pageSize.toString(),
    };

    if (email) params.email = email;
    if (status) params.status = status;
    if (uploadedFrom) params.uploadedFrom = uploadedFrom;
    if (uploadedTo) params.uploadedTo = uploadedTo;
    if (software) params.software = software;

    try {
      const result = await offlineService.orders(mode, params); // см. ниже — нужно обновить API
      set({
        orders: result.items,
        totalCount: result.totalCount,
        totalPages: result.totalPages || Math.ceil(result.totalCount / pageSize),
      });
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  },

  setPage: (page) => {
    set({ page });
    // Можно автоматически вызвать fetchOrders, если нужно
  },

  setPageSize: (size) => {
    set({ pageSize: size, page: 1 }); // при смене размера — сброс на первую страницу
  },

  setEmail: (email) => set({ email }),
  setStatus: (status) => set({ status }),
  setUploadedFrom: (date) => set({ uploadedFrom: date }),
  setUploadedTo: (date) => set({ uploadedTo: date }),
  setSoftware: (software) => set({ software }),

  resetFilters: () => {
    set({
      email: '',
      status: null,
      uploadedFrom: '',
      uploadedTo: '',
      page: 1,
      software: ''
    });
  },

  setSelectedFile: (file) => set({ selectedFile: file }),

    fetchOrder: async (id) => {
    const offlineService = new OfflineService();
    try {
      const order = await offlineService.orderInfo(id);
      set({ order });
    } catch (error) {
      console.error('Error fetching order info:', error);
    }
  },
}));

export default useOfflineServiceStore;